export const constant = {
	selector: {
		sessionModal: '#sessionModal',
		url: 'data-keep-alive-url',
		secondsLeftUrl: 'data-seconds-left-url',
		countdown: '#sessionModal-countdown',
		logout: 'data-logout-url',
	},
}
